// Full-document render of the shop-compare/shop-tile page: PageSkeleton (the
// React document shell) wrapping the shared ShopTile compare-grid island,
// rendered inline inside the legacy `.shop-compare-grid` container so it
// hydrates exactly as it did when the legacy page mounted it via include_react.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as ShopTile } from "./ShopTileTemplate";

export const Template = (
    props: templates.ShopTileDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="shop-compare-grid">
                <ShopTile {...props.island} />
            </div>
        </PageSkeleton>
    );
};
